module.exports = __webpack_public_path__ + "8b672345b85a727edc3ae475d3da22e1.pdf";